import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import store from '@/store'

Vue.use(Router)

let routerLocation = window.location.href;
let routerBase = routerLocation.indexOf('/hdbeta/') > -1 ? '/hdbeta/' : '/hd/';

const router =new Router({
  mode: 'history',
  base: routerBase,
  routes
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js